/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable unused-imports/no-unused-vars */
import { useCallback, useEffect, useMemo, useState } from 'react';

import ActionBar from '@/components/action-bar/action-bar';
import viewTypes from '@/constants/action-bar';
import MaterialTable, { MaterialTableColumnProps } from '@/components/material-table/material-table';
import Typography from '@/components/typography/typography';
import Fallback from '@/components/fallback/fallback';
import Menu from '@/components/menu/menu';
import Footer from '@/components/footer/footer';
import useDeepMemo from '@/hooks/use-deep-memo';
import { PageState } from '@erpsquad/common/runtime';
import { usePages } from '@erpsquad/common/runtime';
import { transformTableColumns } from '@/utils/common-utility';
import { appendConditionSafely, defaultCurrencySymbol, getToken } from '@/utils/common';
import logo from '@/assets/images';
import { IPaginationModel } from '@/@types/pagination-model';
import { fetchApi } from '@/utils/api';

import { MenuItem } from '@mui/material';

// import GridCard from './grid-view/grid-view';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

import { templateRoutes } from './utils/common';
import { IEmail, ITemplateProps, Pagination } from './utils/types';
import { useNavigate } from 'react-router-dom';

import { usePermissions } from '@erpsquad/common/runtime';
import { getV1Subjects } from '@/api-client/api.system-feature/api';
import TemplateModal from './template-modal/template-modal';
import CompanySelectionModal from './company-selection-modal/company-selection-modal';

import './templates.scss';


interface ActionData {
	label: string;
	position: number;
}

const Templates: React.FC<ITemplateProps> = ({ type, module, modulePath }) => {
	const { t } = useTranslation();
	const {
		activePage: aPage,
		updatePageInfo,
		schemaFields,
		generatedColumns,
		updateGeneratedColumns,
		// error: pageError
	} = usePages();
	const activePage = useDeepMemo<PageState>(aPage);
	/* LOCAL STATES */
	const [actionAnchorEl, setActionAnchorEl] = useState<null | HTMLElement>(null);
	const viewEmails = localStorage.getItem('email-subjects-view');
	const [actionBarData, setActionBarData] = useState<ActionData[]>(viewEmails ? JSON.parse(viewEmails) : [{ label: 'Table', position: 0 }]);

	const [actionBarActiveTab, setActionBarActiveTab] = useState<string>(viewTypes.TABLE);
	const [paginationModel, setPaginationModel] = useState<Pagination>({ pageNo: 1, limit: 20, totalCount: 0, skip: 0 });
	const [rows, setRows] = useState<any[]>([]);
	const [isFetching, setIsFetching] = useState<boolean>(false);
	const [selectedRow, setSelectedRow] = useState([]);
	const [showTemplateModal, setShowTemplateModal] = useState<IEmail | null>(null);
	const [templateModalSource, setTemplateModalSource] = useState<'view' | 'add'>('add');
	const [showCompanySelectionModal, setShowCompanySelectionModal] = useState<IEmail | null>(null);
	const [companies, setCompanies] = useState<Record<string, any>[]>([]);
	/* VARS */
	const navigate = useNavigate();
	const { pageNo, limit: pLimit, totalCount } = paginationModel;
	const limit = activePage.page_size || pLimit;
	const total = limit ? Math.ceil(totalCount / limit) : 0;
	const skip = limit * (pageNo - 1);
	const permissions = usePermissions();
	const ROUTES = templateRoutes(modulePath, type);

	const SubjectPermissions = permissions?.Subjects || {};
	const ConditionsImport = permissions?.RentalTerms?.ConditionsImport || {};

	const {
		canAdd = false,
		canEdit = false,
		canDelete = false,
	} = SubjectPermissions;

	const { canAdd: canImport = false } = ConditionsImport;

	const handleNewEmail = (email) => {
		if (!companies?.length) {
			enqueueSnackbar('Please add a company first', { variant: 'error' })
			return
		}

		if (companies?.length > 1) {
			setShowCompanySelectionModal(email)
		} else {
			navigate(ROUTES.ADD_TEMPLATE(email._id), { state: { company_id: companies[0]?.id || companies[0]?.value } })
		}
	};

	const rowActionMenu = [
		{
			label: 'New Template',
			handleAction: (email: IEmail) => handleNewEmail(email),
			disabled: (row: any) => !canEdit
		},
		{
			label: 'Add From Template',
			handleAction: (email: IEmail) => {
            setTemplateModalSource('add'); 
            setShowTemplateModal(email); },
			disabled: (row: any) => !canAdd
		}
	];

	/* LOCAL FUNCTIONS */
	const getEmails = useCallback(
		async () => {
			const { sort, filterQueryString, search } = activePage;
			const searchFiters = search ? `&subject.like=${search}` : '';
			const types = [];
			types.push(type)
			if (type == "email") {
				types.push("approval_email")
			}
			const uFilters = appendConditionSafely(filterQueryString, `&type.in=[${types.join(",")}]&module.eq=${module}${searchFiters}`);

			const response = await getV1Subjects({
				...getToken(),
				skip,
				limit,
				// search,
				...(sort && { order: `${sort.id}:${sort.desc ? -1 : 1}` }),
				...(uFilters && uFilters !== '()' && { filters: uFilters })
			});

			setRows(response?.data || []);
			setPaginationModel({ ...paginationModel, ...(response?.pagination || {}) });
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			limit,
			skip,
			activePage?.search,
			activePage?.filterQueryString,
			activePage?.sort
		]
	);

	const getCopmanies = async () => {
		const companiesArr = await fetchApi({ apiKey: 'company', filters: { skip: 0, limit: 100, order: "id:1" } });
		setCompanies(companiesArr?.data || []);
	}

	const tableRows = useMemo(() => rows || [], [rows]);

	const tableColumns = useMemo(
		() =>
			transformTableColumns({
				columns: generatedColumns.columns,
				currencySymbol: (row) =>
					row.original?.currency_data?.symbol || defaultCurrencySymbol(),
				translationFn: t,
				enableFooter: true,
				// redirectionLink: ROUTES.VIEW,
				// redirectionLinkState: (row) => ({ termsAndCondition: row.original }),
				rows: tableRows,
				statusClasses: ``,
			}),
		[tableRows, t, generatedColumns.columns]
	);

	const handlePaginationModel = (model: IPaginationModel) => {
		if (activePage.page_size != model?.limit) {
			updatePageInfo({ page_size: model.limit });
		}
		setPaginationModel(model);
	};

	const cleanUp = () => {
		const pModel = { pageNo: 1, limit: 20, totalCount: 0 };
		setPaginationModel(pModel);
	};

	/* USE EFFECTS */
	useEffect(() => {
		getEmails();
	}, [getEmails]);


	useEffect(() => {
		getCopmanies();
		return cleanUp;
	}, []);
	useEffect(() => {
		if (actionBarData?.length) {
			localStorage.setItem('email-subjects-view', JSON.stringify(actionBarData));
		}
	}, [actionBarData]);

	/* JSX STRUCTURE STARTED */
	return (
		<section className='templates'>
			<ActionBar
				title={type === 'email' ? 'Emails' : 'PDFs'}
				data={actionBarData}
				setData={setActionBarData}
				active={actionBarActiveTab}
				setActive={setActionBarActiveTab}
				handleSearch={(search) => {
					updatePageInfo({ search });
					setPaginationModel({ ...paginationModel, pageNo: 1 });
				}}
				disabledViews={['Kanban', 'Calendar', 'Gantt', viewTypes.GRID]}
				fields={schemaFields}
				selectedIds={selectedRow}
				button={false}
			/>
			{actionBarActiveTab === viewTypes.TABLE && (
				<MaterialTable
					rows={tableRows || []}
					columns={tableColumns}
					paginationModel={paginationModel}
					totalPages={total}
					columnOrder={['mrt-row-select', ...generatedColumns.orderKeys]}
					states={{ isLoading: isFetching }}
					onSortingChange={(sort) => updatePageInfo({ sort })}
					enableColumnDragging={false}
					enableEditing={false}
					onSelectRow={(r) =>
						setSelectedRow(r.map((ele) => ele.original.id))
					}
					enableAddCustomField={false}
					rowActionMenu={rowActionMenu}
					isResetRow={false}
					handleColumnOrdering={(colOrder) =>
						updateGeneratedColumns({ orderKeys: colOrder.slice(1) })
					}
					onColumnVisibility={(columns: MaterialTableColumnProps[]) =>
						updateGeneratedColumns({ columns: columns })
					}
					showPreview={true}
							handlePreview={(item) => {
									setTemplateModalSource('view');
									setShowTemplateModal(item);
							}}
				/>
			)}
			{actionBarActiveTab === viewTypes.GRID && (
				<GridCard
					data={tableRows}
					rowActionMenu={rowActionMenu}
				/>
			)}

			{!actionBarActiveTab && (
				<Fallback
					heading={t('rental.settings.termsAndConditions.title')}
					subHeading='No data available'
					icon={<img src={logo.invoiceFallback} />}>
				</Fallback>
			)}

			<Footer
				total={total}
				paginationModel={{
					...paginationModel,
					limit: activePage.page_size
				}}
				handlePaginationModel={handlePaginationModel}
				resource=''
			/>

			{/* Action Menu */}
			<Menu
				anchorEl={actionAnchorEl}
				open={Boolean(actionAnchorEl)}
				onClose={() => setActionAnchorEl(null)}>
				<MenuItem>
					<Typography type='s4' color='theme.secondary.1000'>
						{t('common.upload')}
					</Typography>
				</MenuItem>
				<MenuItem>
					<Typography type='s4' color='theme.secondary.1000'>
						{t('common.print')}
					</Typography>
				</MenuItem>
			</Menu>
			{showTemplateModal && (
				<TemplateModal
					email={showTemplateModal}
					onClose={() => setShowTemplateModal(null)}
					open={showTemplateModal !== null}
					companies={companies}
					templateRoutes={ROUTES}
					source={templateModalSource}
				/>
			)}
			{showCompanySelectionModal && (
				<CompanySelectionModal
					isOpen={showCompanySelectionModal !== null}
					setIsOpen={setShowCompanySelectionModal}
					companies={companies}
					email={showCompanySelectionModal}
					templateRoutes={ROUTES}
				/>
			)}
		</section>
	);
};

export default Templates;
